import { render, staticRenderFns } from "./maxLength-editor.vue?vue&type=template&id=cbb2e7bc&scoped=true&"
import script from "./maxLength-editor.vue?vue&type=script&lang=js&"
export * from "./maxLength-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb2e7bc",
  null
  
)

export default component.exports